import React, { useState } from "react";
import { Box, Typography, Stack } from "@mui/material";

import { useNavigate } from "react-router-dom";

import { btnStyOne } from "../ui-elements/styles-button";
import { ImageUpload } from "../image-upload";
import {
  OnboardApiKycData,
  OnboardVerifyAccountData,
} from "../../interface/onboard";
import { LoadingButton } from "@mui/lab";
import { OnboardingVerificationModal } from "./modal";
import { useMutation } from "@tanstack/react-query";
import { apiOnboardingKyc } from "../../api/authentication";
import { useNotificationService } from "../../hooks/notification";
import { useDispatch } from "react-redux";
import { setVerification_status } from "../../store/contentSlice";
import useResponsive from "../../hooks/useResponsive";

export const AccountOnboardingContent = ({
  user_data,
}: {
  user_data: OnboardVerifyAccountData;
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isMedium = useResponsive("down", "md", "xl");
  const [modal_state, setModal_state] = useState(false);
  const { showNotification } = useNotificationService();
  const [kyc, setKyc] = useState<File | null>(null);
  const handle_selected_image = (image: { data_url: any; file: File }[]) => {
    setKyc(image[0]?.file);
  };
  
  const mutation = useMutation({
    mutationFn: (fields: OnboardApiKycData) => apiOnboardingKyc(fields),
    onSuccess: (data) => {
      if (data?.status === "error") {
        if ("details" in data) {
          showNotification(
            data?.details?.message || data.details[0] || "Unknown error",
            "error"
          );
          return;
        }
        return;
      }
      if (data.status === 201) {
        dispatch(setVerification_status("complete"));
        handle_modal();
      }
    },
    onError: (error) => {
      showNotification("Server error", "error");
    },
  });
  const on_submit = () => {
    if (kyc === null) {
      showNotification(
        "Kindly upload voters card or Skip this  process",
        "warning"
      );
      return;
    }
    mutation.mutate({
      name: user_data?.name,
      dob: user_data?.dob,
      gender: user_data?.gender,
      state_id: user_data?.state_id?.toString(),
      local_government_id: user_data?.local_government_id?.toString(),
      kyc: kyc,
    });
  };

  const handle_modal = () => {
    setModal_state(!modal_state);
  };
  return (
    <>
      <OnboardingVerificationModal
        open={modal_state}
        modal_handler={handle_modal}
      />
      <Box sx={{ width: isMedium ? "94%" : 620, mx: "auto" }}>
        <Box sx={{ my: 2 }}>
          <Typography
            variant="h3"
            sx={{
              fontWeight: 500,
              color: "#26203B",
              textAlign: "center",
            }}
          >
            Upload a clear picture of your national voter's card
          </Typography>
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 400,
              color: "#9C9AA5",
              textAlign: "center",
              width: "90%",
              mx: "auto",
            }}
          >
            Please upload a clear image of your national voter's card to verify
            your identity and ensure secure access to the platform.
          </Typography>
        </Box>

        <ImageUpload
          multiple={false}
          styles={{}}
          showText={true}
          onSelect={handle_selected_image}
        />
        <Box sx={{ width: isMedium ? "90%" : "80%", mx: "auto" }}>
          <Stack direction={"row"} justifyContent={"center"}>
            <LoadingButton
              onClick={on_submit}
              variant="contained"
              loading={mutation.isPending}
              sx={{ ...btnStyOne, width: isMedium ? "90%" : "80%" }}
            >
              Continue
            </LoadingButton>
          </Stack>
        </Box>
      </Box>
    </>
  );
};
